import { Outlet } from 'react-router-dom';

export function AppLayout() {
  return (
    <div className="min-h-screen bg-climb-teal text-climb-paper">
      <header className="no-print">
        <div className="mx-auto flex max-w-4xl items-center justify-end px-6 py-4">
          <a
            href="https://climb.ai"
            target="_blank"
            rel="noreferrer"
            aria-label="Climb home (climb.ai)"
            className="inline-flex"
          >
            <img src="/climb-logo.svg" alt="Climb" className="h-6 w-auto" />
          </a>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}
